export const muiThemeColorsLight = {
  primary: {
    main: "#005a9a",
  },
  secondary: {
    main: "#3dc2ff",
  },
  error: {
    main: "#eb445a",
  },
  warning: {
    main: "#ffc409",
  },
  success: {
    main: "#2dd36f",
  },
};

export const muiThemeColorsDark = {
  primary: {
    main: "#0086E5",
  },
  secondary: {
    main: "#3dc2ff",
  },
  error: {
    main: "#eb445a",
  },
  warning: {
    main: "#ffc409",
  },
  success: {
    main: "#2dd36f",
  },
};
